export default "__VITE_ASSET__ClPe_xeI__"